import { Component } from '@angular/core';

@Component({
  selector: 'app-inventory-price-audit-trail',
  standalone: false,
  
  templateUrl: './inventory-price-audit-trail.component.html',
  styles: ``
})
export class InventoryPriceAuditTrailComponent {

}
